import './sma';
import './smaa';
import './ema';
import './emaa';
import './bb';
import './bba';
import './rsi';
import './rsia';
import './macda';



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/indicators/index.js